import { fetchSurveyDrilldown } from './actions';
import { getDefaultAtsFilters, buildReportsSlice } from '../common/ats-filters';

const constructDrilldownData = (payload) => {
  const k1Map = payload?.data?.lookups?.k1;
  const k2Map = payload?.data?.lookups?.k2;
  const k3Map = payload?.data?.lookups?.k3;
  const k4Map = payload?.data?.lookups?.k4;

  const returnData = payload?.data?.table?.map((data) => {
    // eslint-disable-next-line no-unused-vars
    const [
      ,
      k1,
      k2,
      k3,
      k4,
      job_name,
      job_id,
      department,
      nps,
      survey_name,
      survey_id,
    ] = data;
    return {
      hm_user: k1Map?.[k1],
      ats_application: k2Map?.[k2],
      primary_recruiter: k3Map?.[k3],
      primary_hm: k4Map?.[k4],
      job_name: job_name,
      job_id: job_id,
      department: department,
      nps: nps,
      survey_name: survey_name,
      survey_id: survey_id,
    };
  });
  return returnData;
};

const initialState = {
  ...getDefaultAtsFilters(),

  isDrillLoading: false,
  initialLoading: false,
  drilldownData: [],
  totalCount: 0,
  currentDrillPage: 1,
};

const extraReducers = {
  [fetchSurveyDrilldown.pending]: (state, { meta }) => {
    const { drilldown } = meta?.arg || {};
    if (drilldown.page === 1) {
      state.initialLoading = true;
    } else {
      state.isDrillLoading = true;
    }
  },
  [fetchSurveyDrilldown.fulfilled]: (state, { meta, payload = {} }) => {
    if (!payload) {
      return;
    }
    state.isDrillLoading = false;
    state.initialLoading = false;

    const { drilldown } = meta?.arg || {};
    const newData = constructDrilldownData(payload);

    state.totalCount = payload?.data?.pagination?.total_count;

    if (drilldown.page === 1) {
      state.drilldownData = newData;
    } else {
      state.drilldownData = [...state.drilldownData, ...newData];
    }
    state.currentDrillPage = drilldown.page;
  },
  [fetchSurveyDrilldown.rejected]: (state, action) => {
    if (
      action.error?.name === 'AbortError' ||
      action.error?.name === 'CanceledError'
    ) {
      return;
    }
    state.isDrillLoading = false;
    state.initialLoading = false;
  },
};

export const { reducer, actions } = buildReportsSlice({
  name: 'atsSurveyReport',
  initialState,
  extraReducers,
});

export const {
  applyFilter,
  setFiltersData,
  resetFilter,
  applyTimeFrame,
  applyViewBy,
  applyGroup,
  applySearch,
  resetDrillDown,
} = actions;
export default reducer;
